import { type SectionType } from '../../sections/SectionTypeContext.tsx';
import { type IBaseWidget } from '../IBaseWidget.ts';
import { LabelLayout, type WidgetType } from '../Widget.ts';
import { hasWidgetCreationDefaults } from './hasWidgetCreationDefaults.ts';
import { BLOCK_LABEL_WIDGET_TYPES } from './inputs/common/label-layout/hasBlockLabelLayout.ts';

/**
 * Feature flag "etichette dei campi di scelta come testo".
 *
 * Quando `ENABLE_WIDGET_BLOCK_LABELS` è attivo, nella configurazione dei
 * widget di scelta compare l'opzione di disposizione etichetta
 * (flottante/a blocco) e nel Popover "Creazione nuovi Elementi" è
 * disponibile il default a blocco per i nuovi widget (disattivo di default).
 * Disattivo di default (assente ⇒ non abilitato).
 */
export class WidgetBlockLabelsLogic {
  static isEnabled() {
    return process.env.ENABLE_WIDGET_BLOCK_LABELS === 'true';
  }

  /**
   * Partial da passare a `WidgetRepository.getInitial` alla creazione di un
   * nuovo widget nel builder: imposta l'etichetta a blocco solo se il default
   * è attivo (`enabled`, dal Popover "Creazione nuovi Elementi"), la sezione
   * è FRONTOFFICE o BACKOFFICE e il widget è di scelta. Negli altri casi
   * ritorna `undefined` e la creazione resta invariata.
   *
   * Su Scelta Singola/Multipla il valore ha effetto solo nelle varianti
   * radio/checkbox: nelle varianti a tendina resta salvato ma inerte
   * (vedi `hasBlockLabelLayout`).
   */
  static getInitialWidgetPartial(
    widgetType: WidgetType,
    sectionType: SectionType,
    enabled: boolean,
  ): Pick<IBaseWidget, 'layout'> | undefined {
    if (!enabled) return undefined;
    if (!hasWidgetCreationDefaults(sectionType)) return undefined;
    if (!BLOCK_LABEL_WIDGET_TYPES.includes(widgetType)) return undefined;

    return { layout: { labelLayout: LabelLayout.Block } };
  }
}
